import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Logo } from '@stashinvest/ui';
import { isMobileWeb } from 'stash/utils';
import { Text } from '@stashinvest/react-components';
import { XCircleIcon } from '@stashinvest/react-assets';

const DesktopDownloadBanner = styled.div`
	position: fixed;
	top: 0;
	height: 64px;
	width: 100%;
	z-index: 11;

	color: rgba(0, 31, 41, 1);

	background: ${({ light }) => (light ? 'rgba(10, 10, 12, 1)' : 'rgba(50, 53, 55, 1)')};
`;

const MobileDownloadBanner = styled.div`
	position: fixed;
	top: 0;
	height: 76px;
	width: 100%;
	z-index: 11;

	color: rgba(0, 31, 41, 1);

	background: ${({ light }) => (light ? 'rgba(10, 10, 12, 1)' : 'rgba(50, 53, 55, 1)')};
`;

const DesktopDismissButton = styled.button`
	position: absolute;
	top: 50%;
	right: 40px;
	transform: translateY(-50%);

	text-decoration: underline;
	color: rgba(177, 177, 177, 1);
`;

export const DownloadBanner = ({ dismiss = () => {} }) => {
	const isMobile = isMobileWeb();
	const { mode } = useTheme();

	return (
		<>
			{isMobile ? (
				<MobileDownloadBanner
					light={mode === 'light'}
					className="p-contentSmall flex justify-between items-center"
				>
					<div
						className="h-full flex gap-layout2XS"
						onClick={() => {
							window.open('https://stash.onelink.me/v0u2/tyvqyilr', '_blank');
						}}
						role="link"
						tabIndex={0}
						onKeyDown={(e) => e.preventDefault()}
					>
						<div className="h-full aspect-square grid place-items-center bg-gradientSmall3 rounded-xl">
							<Logo
								className="cursor-default shrink"
								color="text-fill1"
								height="0.5rem"
							/>
						</div>
						<div>
							<Text textStyle="header2XS" className="text-[white]">
								Download Stash app.
							</Text>
							<Text textStyle="bodyMediumStandard" className="text-[rgba(218,218,218,1)]">
								Available on iOS and Android
							</Text>
						</div>
					</div>
					<button className="grid place-items-start" onClick={dismiss}>
						<XCircleIcon size={'small'} className="text-[white]" />
					</button>
				</MobileDownloadBanner>
			) : (
				<DesktopDownloadBanner
					light={mode === 'light'}
					className="py-content1_5XS flex justify-center items-center gap-layout2XS relative"
				>
					<div className="h-full aspect-square grid place-items-center bg-gradientSmall3 rounded-xl">
						<Logo className="cursor-default shrink" color="text-fill1" height="0.5rem" />
					</div>
					<Text textStyle="bodyMediumStandard" className="text-[rgba(215,215,215,1)]">
						Download the Stash app on{' '}
						<a
							className="text-inversePrimary font-semibold"
							href="https://apps.apple.com/us/app/stash-investing-made-easy/id1017148055?lid=6fuw0go528b4"
							target="_blank"
							rel="noopener noreferrer"
						>
							iOS
						</a>{' '}
						and{' '}
						<a
							className="text-inversePrimary font-semibold"
							href="https://play.google.com/store/apps/details?id=com.stash.stashinvest&hl=en&lid=l892xj31xhmb&pli=1"
							target="_blank"
							rel="noopener noreferrer"
						>
							Android
						</a>
					</Text>
					<DesktopDismissButton onClick={dismiss}>Dismiss</DesktopDismissButton>
				</DesktopDownloadBanner>
			)}
		</>
	);
};

DownloadBanner.propTypes = {
	dismiss: PropTypes.func,
};
